import { render, staticRenderFns } from "./Players.vue?vue&type=template&id=0e36e8a1&scoped=true&"
import script from "./Players.vue?vue&type=script&lang=ts&"
export * from "./Players.vue?vue&type=script&lang=ts&"
import style0 from "./Players.vue?vue&type=style&index=0&id=0e36e8a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e36e8a1",
  null
  
)

export default component.exports